import { styled } from "@mui/material";
import MuiDialogContent from "@mui/material/DialogContent";

const DialogContent = styled(MuiDialogContent)(({ theme }) => ({ paddingBottom: theme.spacing(1) }));

export default DialogContent;
